import {
  getInstance,
  getCleanInstance,
} from '@portal/repositories/securitySdkConfig';

const BASE_URL = '/document-pendent';

const PendingDocumentsApi = {
  getPendingDocuments: async () => {
    const instance = getInstance();
    const { data } = await instance.get('/document-pendent');

    return data.rows as models.PendingDocument[];
  },

  saveDocument: async (props: models.PendingDocumentRequest) => {
    const instance = getInstance();
    const { data } = await instance.put(
      `${BASE_URL}/v2/${props.id}/save-document`,
      {
        address: props.address,
        documentType: props.type,
        document: props.document,
        documentBack: props.documentBack,
        encryptedJwtDocumentFront: props.encryptedJwtDocumentFront ?? props.jwt,
        encryptedJwtDocumentBack: props.encryptedJwtDocumentBack,
      }
    );

    return data;
  },

  saveDocumentIdwall: async (props: models.PendingDocumentIdwallRequest) => {
    const instance = getInstance();
    const { data } = await instance.put(
      `${BASE_URL}/v2/${props.id}/save-document`,
      {
        ...props,
      }
    );

    return data;
  },

  uploadPicture: async (
    imageBody: Buffer,
    urlToUpload: string,
    mimeType: string
  ) => {
    const instance = getCleanInstance(urlToUpload);
    const { data } = await instance.put('', imageBody, {
      headers: {
        'Content-Type': mimeType,
      },
    });

    return data;
  },
};

export default PendingDocumentsApi;
